'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var index_esm = require('./index.esm-c41adfff.js');

var DropdownMenu = function (_a) {
    var title = _a.title, imageUrl = _a.imageUrl, items = _a.items, backgroundColor = _a.backgroundColor, color = _a.color, showUserAvatarLaunchDarkly = _a.showUserAvatarLaunchDarkly, showUserAvatarDomainTheme = _a.showUserAvatarDomainTheme;
    var _b = tslib_es6.__read(React.useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    var containerRef = React.useRef(null);
    var withAvatar = (imageUrl && showUserAvatarLaunchDarkly && showUserAvatarDomainTheme);
    index_esm.useOuterClick(containerRef, function () {
        setOpen(false);
    });
    var handleItemClick = React.useCallback(function (action) { return function () {
        action();
        setOpen(false);
    }; }, []);
    var handleOpen = React.useCallback(function () {
        setOpen(function (prevProps) { return !prevProps; });
    }, []);
    return (React__default.createElement(index_esm.Container, { ref: containerRef, backgroundColor: backgroundColor, color: color, withAvatar: withAvatar },
        React__default.createElement(index_esm.Button, { onClick: handleOpen, withAvatar: withAvatar, "data-testid": "dropdown-menu_button" },
            withAvatar && React__default.createElement(index_esm.Image, { src: imageUrl }),
            title,
            React__default.createElement(index_esm.Icon, { icon: ['fas', isOpen ? 'caret-up' : 'caret-down'], color: "white" })),
        React__default.createElement(index_esm.Content, { isOpen: isOpen, "data-testid": "dropdown-content" }, items
            && items.map(function (item, index) { return (
            // Disabling because it already exists
            // eslint-disable-next-line react/no-array-index-key
            React__default.createElement(index_esm.Item, { key: index, index: index, onClick: handleItemClick(item.action) }, item.title)); }))));
};

exports.DropdownMenu = DropdownMenu;
